import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { SOCIO_CATEGORIES } from "@/lib/categories";
import { RotateCcw, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const CategoryEditor = ({ appId, current, canEdit, onSaved }) => {
  const [busy, setBusy] = useState(false);
  if (!canEdit) {
    return <span className="text-sm font-bold bg-white/15 rounded-full px-3 py-1" data-testid="ficha-category">{current || "—"}</span>;
  }
  const change = async (cat) => {
    if (!cat || cat === current) return;
    if (!window.confirm(`¿Cambiar la categoría de «${current || "—"}» a «${cat}»? El % se recalcula.`)) return;
    setBusy(true);
    try {
      await api.post(`/admin/applications/${appId}/change-category`, { categoria: cat });
      toast.success("Categoría actualizada y beca recalculada.");
      onSaved();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <span className="inline-flex items-center gap-2">
      <select value={current || ""} disabled={busy} onChange={(e) => change(e.target.value)}
        className="text-sm font-bold bg-white/15 text-white rounded-full px-3 py-1 border border-white/30 cursor-pointer" data-testid="ficha-category">
        {!current && <option value="" className="text-black">—</option>}
        {SOCIO_CATEGORIES.map((c) => <option key={c.value} value={c.value} className="text-black">{c.value} · {c.uf} UF</option>)}
      </select>
      {busy && <Loader2 className="w-4 h-4 animate-spin" />}
    </span>
  );
};

export const ReopenButton = ({ appId, status, onSaved }) => {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (user?.role !== "superadmin" || status !== "processed") return null;
  const reopen = async () => {
    const reason = window.prompt("Motivo para reabrir la solicitud (queda en la auditoría):");
    if (reason === null) return;
    setBusy(true);
    try {
      await api.post(`/admin/applications/${appId}/reopen`, { reason });
      toast.success("Solicitud reabierta. Puedes corregir datos y volver a decidir.");
      onSaved();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <Button variant="outline" onClick={reopen} disabled={busy} className="rounded-xl border-2" data-testid="btn-reopen-application">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><RotateCcw className="w-4 h-4 mr-1" /> Reabrir solicitud</>}
    </Button>
  );
};
